import { render, staticRenderFns } from "./TransferPiecesButton.vue?vue&type=template&id=f6a0380e&"
import script from "./TransferPiecesButton.vue?vue&type=script&lang=js&"
export * from "./TransferPiecesButton.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports